module.exports = __webpack_public_path__ + "components/flag/static/square/tj-6b73ae5bc3e199ee0dc27a2ac5ab0090.svg";